<template>
	<v-container grid-list-md>
		<v-card>
			<v-card-title primary-title>
				{{ category.name }}
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-layout>
					<v-flex xs12 md4>
						<v-img
							:src="category.image_url"
							width="300"
							height="300"
						></v-img>
					</v-flex>
					<v-flex xs12 md8>
						<b>Description</b>
						<p v-html="category.description"></p>
						<b>Total Products</b>
						<p>{{ products_count }}</p>
						<b>Apply category schedule to all products</b>
						<p>&nbsp;</p>
						<v-btn @click="applySchedule" :loading="loading"
							>Apply Now</v-btn
						>
					</v-flex>
				</v-layout>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
export default {
	props: ["category", "products_count"],

	data() {
		return {
			loading: false,
		};
	},

	methods: {
		applySchedule() {
			this.$inertia.post(
				this.$route("tenant.category_product_schedules.store", {
					tenant: this.$page.props.tenant.id,
					category: this.category.uuid,
				})
			);
		},
	},
};
</script>